import { MediaType } from '../../../form/fields/FormFieldUploadMedia'
import type { ClassifiedSpecialty, Status } from '../Classified'

import { SImage } from './Image'
import { SUser } from './User'
import { SClassifiedView } from './ClassifiedView'

export type SClassified = {
  id?: number
  documentId?: string
  title?: string
  slug?: string
  description?: string | any[] | null
  keywords?: string
  summary?: string
  address?: string
  additionalAddress?: string
  classifiedStatus?: Status | null
  block?: Array<
    | SClassifiedAdoptBlock
    | SClassifiedAssistantBlock
    | SClassifiedBlockOperatoryBlock
    | SClassifiedCarabinBlock
    | SClassifiedCoordinatorBlock
    | SClassifiedEmployeeBlock
    | SClassifiedGardeBlock
    | SClassifiedInstallationBlock
    | SClassifiedLiberalBlock
    | SClassifiedOperatoryBlock
    | SClassifiedReplacementBlock
    | SClassifiedSecretaryBlock
  >
  emitter?: SClassifiedEmitter | null
  mainMediaType?: MediaType
  image?: SImage | null
  videoUrl?: string
  publishedAt?: string
  archivedAt?: string
  updatedAt?: string
  classifiedCategory?: SClassifiedCategory | null
  classified_answers?: Array<SClassifiedAnswer>
  medias?: Array<SClassifiedMedia>
  user?: SUser | null
  lat?: number
  long?: number
  city?: string
  postalCode?: string
  department?: string
  classified_views?: Array<SClassifiedView>
  filled?: boolean
  service?: string
  user_published_classifieds_count?: number
}

export type SClassifiedCategory = {
  id?: number
  documentId?: string
  name?: string
  slug?: string
  user_profiles?: Array<any>
  form?: string
  classifieds?: Array<SClassified>
  totalClassifieds?: number
}

export type SClassifiedAnswer = {
  id?: number
  documentId?: string
  birthdate?: string
  city?: string
  civility?: string
  classified?: SClassified | null
  country?: string
  disponibilityEndTwo?: string
  disponibilityStart?: string
  disponibilityStartTwo?: string
  disponibillityEnd?: string
  document?: any
  email?: string
  jobDuration?: string
  jobDurationCarabin?: string
  lastname?: string
  message?: string
  name?: string
  phone?: string
  postcode?: string
  schoolingLevel?: string
  street?: string
  studentCard?: any
  university?: string
  answer_user?: SUser | null
  classifiedStatus?: Status | null
  createdAt?: string
  seen?: boolean
}

export enum EmitterType {
  Doctor = 'Doctor',
  Organization = 'Organisation',
}

export type SClassifiedEmitter = {
  id?: number
  documentId?: string
  type?: EmitterType
  presentation?: string
  website?: string
  recipients?: Array<{ value: string }>
  logo?: SImage | null
  classifieds?: Array<SClassified>
  name?: string
  user?: SUser | null
}

export type SClassifiedMedia = {
  id?: number
  documentId?: string
  type: string
  title: string
  description: string
  videoUrl: string
  photo?: SImage | null
  document?: any
}

export type SClassifiedOfferType = {
  id?: number
  documentId?: string
  name: string
}

export type SClassifiedSpecialty = {
  id?: number
  documentId?: string
  name: string
}

export type SClassifiedCabinetType = {
  id?: number
  documentId?: string
  name: string
}

export type SClassifiedSecretariat = {
  id?: number
  documentId?: string
  name: string
}

export type SClassifiedAdoptBlock = {
  id: string
  speciality: SClassifiedSpecialty
  patronages: number
}

export type SClassifiedAssistantBlock = {
  id: string
  cabinetType: SClassifiedCabinetType
  speciality: SClassifiedSpecialty
  saturday: boolean
  gestures: string
}

export type SClassifiedBlockOperatoryBlock = {
  id: string
  establishmentName: string
  group: Array<string>
  speciality: SClassifiedSpecialty
  description: string
  operatoryHelpProvided: boolean
  toolsProvided: boolean
  treatmentType: string
  establishmentApproved: boolean
  availabilities: string
}

export type SClassifiedCarabinBlock = {
  id: string
  startDate: string
  endDate: string
  speciality: SClassifiedSpecialty
  cabinetType: SClassifiedCabinetType
}

export type SClassifiedCoordinatorBlock = {
  id: string
  cabinetType: SClassifiedCabinetType
  saturday: boolean
  experience: boolean
}

export type SClassifiedEmployeeBlock = {
  id: string
  job: string
  contract: string
  startDate: string
  endDate: string
}

export type SClassifiedGardeBlock = {
  id: string
  speciality: SClassifiedSpecialty
  doctors: string
  departments: string
  periods: string
  type: string
}

export type SClassifiedInstallationBlock = {
  id: string
  cabinetType: SClassifiedCabinetType
  specialities: SClassifiedSpecialty
  secretariats: SClassifiedSecretariat
  offerType: SClassifiedOfferType
  startDate: string
}

export type SClassifiedLiberalBlock = {
  id: string
  speciality: SClassifiedSpecialty
  cabinetType: SClassifiedCabinetType
  frequencies: string
  periodMonths: string
  periodDays: Array<any>
  comments: string
}

export type SClassifiedOperatoryBlock = {
  id: string
  speciality: ClassifiedSpecialty
  days: Array<any>
  frequency: string
}

export type SClassifiedReplacementBlock = {
  id: string
  startDate: string
  endDate: string
  period: Array<any>
  negociableDays: boolean
  sector: Array<string>
  softwares: string
  rate: number
  collabReplacement: boolean
  cabinetType: SClassifiedCabinetType
  guard: boolean
  specialities: SClassifiedSpecialty
}

export type SClassifiedSecretaryBlock = {
  id: string
  saturday: boolean
  experience: boolean
  cabinetType: SClassifiedCabinetType
  speciality: SClassifiedSpecialty
}

export type SClassifiedAlert = {
  id?: number
  documentId?: string
  user?: SUser | null
  terms?: string
  localisation?: string
  specialities?: Array<SClassifiedSpecialty>
  categories?: Array<SClassifiedCategory>
}
